import React from 'react';
import { useTranslation } from 'react-i18next';

import Button from '@material-ui/core/Button';
import Grid, { GridSpacing } from '@material-ui/core/Grid';

import { FooterBaseStyle } from './OffLineJudgeStyle';

type OffLineJudgeFooterProps = {
  onClickSelectButton: () => void;
  buttonEnable: boolean;
};
const OffLineJudgeFooter: React.FC<OffLineJudgeFooterProps> = (props) => {
  const { t } = useTranslation();
  const footerStyle = FooterBaseStyle();
  return (
    <Grid
      container
      justify="flex-start"
      spacing={1}
      direction="row"
      alignItems="center"
      style={{ width: 'calc(100vw - 12px)' }}
    >
      <Grid item xs={2}>
        <Button
          variant="contained"
          className={footerStyle.buttonStyle}
          color="primary"
          disabled={!props.buttonEnable}
          disableElevation
          onClick={(e) => {
            props.onClickSelectButton();
          }}
        >
          {t('OffLineJudgeFooter.実行','実行')}
        </Button>
      </Grid>
    </Grid>
  );
};

export default OffLineJudgeFooter;
